const getSubrOverViewHeader = (data: any, paramName: string) => {
  switch (paramName) {
    case 'staff_id':
      return data.staff;
    default:
      return '';
  }
};

export { getSubrOverViewHeader };
